import React from "react";
import { ViewerItemsVisibilityContext } from "./viewer-items-visibility-context-props.ts";

const useViewerItemsVisibilityContext = () => {
    const context = React.useContext(ViewerItemsVisibilityContext);
    if (context === undefined) {
        throw new Error('useViewerVisibilityContext must be used within a ViewerVisibilityProvider');
    }
    return context;
};

export default useViewerItemsVisibilityContext;